const prependStaticClass = (context, classlist) => {
  if (context.data.staticClass) context.data.staticClass.split(' ').reduce((acc, next) => { acc.push(next); return acc }, classlist)
  return classlist.join(' ')
}

const createClass = (el, breakpoint, size) => [el, breakpoint, size].filter(x => !!x).join('-')

export {
  prependStaticClass,
  createClass
}
